import SpinModel from "../../../vendor_core/core/src/model/SpinModel";
import { State } from "../../../vendor_core/core/src/states/State";
import { GameHowl } from "../../../vendor_core/core/src/utils/GameHowl";
import { Tween } from "../../../vendor_core/core/src/Tween";
import CommandManager from "../../../vendor_core/core/src/commands/CommandManager";
import { Commands } from "../../../vendor_core/core/src/commands/CommandEnum";
import { VendorCommandsEnum } from "../commands/VendorCommandsEnum";


export default class VendorExitFreespinsState extends State {

    protected winMusic: GameHowl | undefined;

    public enter() {
        CommandManager.execute(Commands.UPDATE_FREE_SPINS, SpinModel.freespinWinnings);
        
        Tween.delayedCall(2, () => {
            CommandManager.execute(VendorCommandsEnum.FEATURE_FINISHED);
            this.showPopup();
        }, [], this);

        super.enter();
    }

    public showPopup() {
       
    }
}
